module.exports = new __parcel__URL__("roadmap-dark.94c33e4a.svg").toString();